import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import MyLoader from "../../../component/reusebale/myLoader";
import { ShowSuccess } from "../../../utils/ToasFunction";
import AppealPopup from "../../popup/appealPopup";
import ParagraphTag from "../../reusebale/Paragraph";
import ButtonTag from "../../reusebale/button";
import ImageTag from "../../reusebale/imageTag";

import BaseUrl from "../../../constants/BaseUrl";
import db from "../../../db/index.json";

import * as AuthAction from "../../../store/actions/auth/AuthAction";

const PlanSection = ({ onButtonClick }) => {
  const { userCompleteProfile, loginSuccess } = useSelector(
    (state) => state.auth
  );
  const dispatch = useDispatch();
  const [completeProfileData, setCompleteProfileData] = useState({
    plansData: [],
  });
  const [isAppealPopup, setisAppealPopup] = useState(false);

  const [appealMessage, setAppealMessage] = useState("");

  const closeReasonPopup = () => {
    setisAppealPopup(false);
  };

  useEffect(() => {
    const fetchCompleteProfileData = () => {
      const data = db.completeProfileData;

      // Apply profile completion status when setting initial data
      if (userCompleteProfile) {
        const updatedPlansData = data.plansData.map((plan) => {
          if (
            plan.name === "Company Information" &&
            userCompleteProfile?.companyInformation
          ) {
            return { ...plan, isCheck: true };
          }
          if (
            plan.name === "Personal Information" &&
            userCompleteProfile?.personalInformation
          ) {
            return { ...plan, isCheck: true };
          }

          return plan;
        });

        setCompleteProfileData({
          ...data,
          plansData: updatedPlansData,
        });
      } else {
        setCompleteProfileData(data);
      }
    };

    fetchCompleteProfileData();
  }, [userCompleteProfile]);

  const [Loading, setLoading] = useState(false);

  const SendProfileForApproval = (profileId) => {
    setLoading(true);
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

    const raw = JSON.stringify({
      recordId: profileId,
    });

    const requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}landlord/profile/sendProfileRequestForApproval`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === 200) {
          ShowSuccess("Profile send for approval");
          dispatch(
            AuthAction.GetLandlordProfile(
              loginSuccess?.user?._id,
              loginSuccess.token
            )
          );
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((error) => console.error(error));
  };

  const SendAppealRequestHandler = () => {
    setLoading(true);
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

    const raw = JSON.stringify({
      recordId: userCompleteProfile._id,
      status: "appeal",
      isAppeal: true,
      appealRequest: appealMessage,
    });

    const requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${BaseUrl}landlord/profile/landlordProfileAppeal`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === 200) {
          ShowSuccess("Profile send for approval");

          dispatch(
            AuthAction.GetLandlordProfile(
              loginSuccess?.user?._id,
              loginSuccess.token
            )
          );
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((error) => console.error(error));
  };

  // console.log('Remove later')

  return (
    <div>
      <div className="bg-white rounded-2xl py-5 px-4 w-full mt-6 shadow-md shadow-gray-200 transition-all duration-300 hover:opacity-90">
        {completeProfileData.plansData.map((item, i) => (
          <div
            key={i}
            className="w-[95%] mx-auto mt-3"
            onClick={() => onButtonClick(item.name)}
          >
            <div className="bg-[#E6BF9F1A] hover:border-2 hover:border-themeColor cursor-pointer transition-all duration-100 ease-in-out rounded-lg flex items-center py-2">
              <div className="w-[5%] flex justify-center">
                <ImageTag
                  path="/assets/daashboard/profile-complete/caret-right.png"
                  classes="w-[6px]"
                  altText="caret-right"
                />
              </div>
              <div className="w-[85%] flex items-center">
                <ImageTag
                  path={item.imagePath}
                  classes="w-[40px]"
                  altText="plan-image"
                />
                <ParagraphTag
                  content={item.name}
                  classes="text-darkColor font-popinsSemiBold text-sm pl-3"
                />
              </div>
              <div className="w-[10%] flex justify-center">
                <input
                  type="checkbox"
                  id={`checkbox-${i}`}
                  checked={item.isCheck || false}
                  readOnly
                  className="h-6 w-6 rounded-full border-2 border-statusColor bg-white checked:bg-statusColor checked:border-statusColor focus:ring-statusColor cursor-pointer"
                />
              </div>
            </div>
          </div>
        ))}
      </div>
      {userCompleteProfile?.approvedStatus === "save" &&
        userCompleteProfile.companyInformation &&
        userCompleteProfile.personalInformation && (
          <div className="w-[20%] mt-6">
            {Loading ? (
              <div className="flex justify-center items-center">
                <MyLoader />
              </div>
            ) : (
              <ButtonTag
                onSubmit={(e) => {
                  e.preventDefault();
                  SendProfileForApproval(userCompleteProfile._id);

                  // dispatch(AuthAction.SendProfileForApprovalAction(userCompleteProfile._id))
                }}
                name={completeProfileData.approval}
                classes="text-sm text-center bg-themeColor text-white"
              />
            )}
          </div>
        )}
      {userCompleteProfile?.approvedStatus === "sendForApproval" && (
        <div className=" w-[60%] mx-auto mt-8 flex">
          <ImageTag
            path="/assets/daashboard/profile-complete/status.png"
            classes="w-[70px]"
            altText="login"
          />
          <div className="pl-3">
            <ParagraphTag
              content="Pending Approval"
              classes="text-darkColor font-popinsSemiBold text-xl"
            />
            <ParagraphTag
              content="Your profile has been submitted for review. You will get access to the dashboard as soon as you profile has been approved by the admin."
              classes="text-paraColor font-popinsRegular text-xs mt-1"
            />
          </div>
        </div>
      )}

      {userCompleteProfile?.approvedStatus === "rejected" && (
        <div className=" w-[60%] mx-auto mt-8 flex">
          <ImageTag
            path="/assets/daashboard/profile-complete/remove.png"
            classes="w-[80px] h-[80px]"
            altText="login"
          />
          <div className="pl-3">
            <ParagraphTag
              content="Profile Rejected"
              classes="text-darkColor font-popinsSemiBold text-xl"
            />
            <ParagraphTag
              content={userCompleteProfile?.rejectReson}
              classes="text-paraColor font-popinsRegular text-xs mt-1 line-clamp-2"
            />
            <ButtonTag
              onSubmit={(e) => {
                setisAppealPopup(true);
              }}
              name="Appeal Request"
              classes="text-sm text-center bg-themeColor text-white mt-2"
            />
          </div>
        </div>
      )}

      {userCompleteProfile?.approvedStatus === "appeal" && (
        <div className=" w-[60%] mx-auto mt-8 flex">
          <ImageTag
            path="/assets/daashboard/profile-complete/time-left.png"
            classes="w-[80px] h-[80px]"
            altText="login"
          />
          <div className="pl-3">
            <ParagraphTag
              content="Appeal Submitted"
              classes="text-darkColor font-popinsSemiBold text-xl"
            />
            <ParagraphTag
              content={userCompleteProfile?.appealRequest}
              classes="text-paraColor font-popinsRegular text-xs mt-1 line-clamp-2"
            />
          </div>
        </div>
      )}

      {/* y appealPopup m lgega submit pr jha s tm appeal ki hit maroge */}
      {/* onReasonSubmit={} */}
      {isAppealPopup && (
        <AppealPopup
          loader={Loading}
          onAppealChange={(e) => {
            setAppealMessage(e.target.value);
          }}
          onReasonSubmit={SendAppealRequestHandler}
          onBack={closeReasonPopup}
        />
      )}
    </div>
  );
};

export default PlanSection;
